import React from "react";
import GmpCourseApplicationTaskList from "../../features/GMPCourseProvider/GmpCourseApplicationTaskList";

const GmpCourseProviderApplicationTaskList = () => {
  return (
    <div>
      <GmpCourseApplicationTaskList />
    </div>
  );
};

export default GmpCourseProviderApplicationTaskList;
